import { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import AuthManager from '../../../core/oidc';
import InfoCard from '../../../components/info-card';

const useStyles = makeStyles({
    text: {
        display: 'block',
        textAlign: 'center',
        marginBottom: 15,
    },
});

const Login = () => {
    const classes = useStyles();
    const [run, setRun] = useState(false);

    useEffect(() => {
        const callback = () => {
            AuthManager.login();
            setRun(true);
        };
        callback();
    }, [run]);

    return (
        <InfoCard>
            <h4 className={classes.text}>Lütfen bekleyin...</h4>
        </InfoCard>
    );
};
export default Login;
